// Aurora hooks for publications with corporate styling
import { useQuery } from '@tanstack/react-query';
import { publicationApi, categoryApi } from '@/lib/client';

interface UsePublicationsParams {
    type?: 'NEWS' | 'PAGE' | 'REPORT';
    status?: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
    categoryId?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    limit?: number;
    page?: number;
}

export const usePublications = (params: UsePublicationsParams = {}) => {
    return useQuery({
        queryKey: ['publications', params],
        queryFn: async () => {
            try {
                // Ambil data dari API
                // Hanya fetch status 'PUBLISHED' karena API publik
                const res = await publicationApi.getPublications({
                    type: params.type,
                    categoryId: params.categoryId,
                    search: params.search,
                    status: 'PUBLISHED',
                    limit: params.limit ? params.limit.toString() : undefined,
                    page: params.page ? params.page.toString() : undefined,
                });
                console.log('Aurora Publications API response:', res);
                return res;
            } catch (error) {
                console.error('Aurora Publications API error:', error);
                throw error;
            }
        },
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export const useFeaturedPublications = (limit: number = 5) => {
    return useQuery({
        queryKey: ['featured-publications', limit],
        queryFn: async () => {
            try {
                const res = await publicationApi.getFeaturedPublications({ type: 'NEWS', limit });
                console.log('Aurora Featured publications API response:', res);
                return res;
            } catch (error) {
                console.error('Aurora Featured publications API error:', error);
                throw error;
            }
        },
        retry: 1,
        staleTime: 5 * 60 * 1000,
    });
};

export const useRecentPublications = (limit: number = 10) => {
    return useQuery({
        queryKey: ['recent-publications', limit],
        queryFn: async () => {
            try {
                const res = await publicationApi.getRecentPublications({ type: 'NEWS', limit });
                console.log('Aurora Recent publications API response:', res);
                return res;
            } catch (error) {
                console.error('Aurora Recent publications API error:', error);
                throw error;
            }
        },
        retry: 1,
        staleTime: 5 * 60 * 1000,
    });
};

export const usePublicationBySlug = (slug: string) => {
    return useQuery({
        queryKey: ['publication', slug],
        queryFn: () => publicationApi.getPublicationBySlug(slug),
        enabled: !!slug,
        retry: 1,
        staleTime: 5 * 60 * 1000,
    });
};

export const useCategories = () => {
    return useQuery({
        queryKey: ['categories'],
        queryFn: async () => {
            try {
                const res = await categoryApi.getCategories();
                console.log('Aurora Categories API response:', res);
                return res;
            } catch (error) {
                console.error('Aurora Categories API error:', error);
                throw error;
            }
        },
        retry: 1,
        staleTime: 10 * 60 * 1000, // 10 minutes
    });
};
